<div class="facilities row">
    {{promptText}}
    <div *ngIf="isLoading" 
         style="width: 100%; height: 155px; background: transparent url('assets/img/loading.gif') no-repeat center center">
         &nbsp;
    </div>
    <div class="facility-notification-div" *ngFor="let facility of facilities">
        <label class="checkbox">
            <input name="{{facility.name}}" type="checkbox" [(ngModel)]="facility.selected">
            {{facility.name}}<span></span>
        </label>
    </div>
</div>